import { Middleware } from 'redux';
import { ReduxState } from '~/types/redux';
import clientSide from '~/helpers/clientSide';
import { trackEvent } from '~/helpers/tracking';

/**
 * Middleware that events when the buy flow (NGC or BAU) changes by watching the value of currentlyInNGC
 */
const buyFlowEventerMiddleware: Middleware = store => {
  // Keep track of the previous value to avoid duplicate logs
  let previousValue: boolean | undefined = (store.getState() as ReduxState).currentlyInNGC;
  
  return next => action => {
    const result = next(action);
    const newValue = (store.getState() as ReduxState).currentlyInNGC;
    
    // Only event if the value has changed
    if ((previousValue !== newValue) && clientSide) {
      trackEvent({
        action: 'flowChanged',
        data: { 
          prevBuyFlow: previousValue ? 'NGC' : 'BAU',
          newBuyFlow: newValue ? 'NGC' : 'BAU'
        }
      });
      
      // Update the previous value for the next action
      previousValue = newValue;
    }
    
    // Return the result of the next dispatch method
    return result;
  };
};

export default buyFlowEventerMiddleware;
